import { render } from "./RollbackPopup.vue?vue&type=template&id=26330721"
import script from "./RollbackPopup.vue?vue&type=script&lang=js"
export * from "./RollbackPopup.vue?vue&type=script&lang=js"

import "./RollbackPopup.vue?vue&type=style&index=0&id=26330721&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__